import gql from 'graphql-tag'

import { PlanStructure, Regime } from '../../../../types/fam-graphql'
import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { PreferencesFragment } from '../../../fragments/PreferencesFragment'
import { ObjectivesFragment } from '../../../fragments/ObjectivesFragment'

const mutation = gql`
  mutation onboard(
    $preferences: PreferencesInput!
    $objectives: ObjectivesInput!
  ) {
    onboard(preferences: $preferences, objectives: $objectives) {
      id
      token
      should_receive_notifications
      notification_frequency
      preferences {
        ...PreferencesFragment
      }
      objectives {
        ...ObjectivesFragment
      }
      favorite_recipes {
        id
      }
      push_preferences {
        installIOS
        installAndroid
        notification
      }
      has_download_menu
    }
  }
  ${PreferencesFragment}
  ${ObjectivesFragment}
`

const transformer = ({ onboard }: any) => onboard

type variables = {
  preferences: {
    express: boolean | null
    portions: number
    regime: Regime
    structure: PlanStructure
  }
  objectives: {
    complete_carbohydrate: number
    dried_vegetable: number
    fish: number
    fruit_and_vegetable: number
    meat: number
    sugary_product: number
  }
}

export default mutationServiceCreator<variables>(mutation, transformer)
